// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"769c4d0f2a9940bdfa78","245":"d15359a6ade70b7b9ef8","452":"de15bec7ebc4fe924405","453":"794dd46ed3fe38359718"}[chunkId] + ".js";
};